<template>
    <div class="form">
        <Form
            ref="info"
            :model="info"
            :rules="ruleValidate"
            :label-width="100"
            :viewonly="isView"
            @submit.native.prevent
        >
            <template v-if="innerMode == FORM_MODE.add">
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem
                            label="客户手机号"
                            prop="cusMobile"
                            :error="mobileError"
                        >
                            <Input
                                v-model="info.cusMobile"
                                :maxlength="100"
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
            </template>
            <template v-else>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="客户姓名" prop="cusName">
                            <Input
                                v-model="info.cusName"
                                :maxlength="100"
                                :readonly="cusNameReadonly"
                            ></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="客户手机号" prop="cusMobile">
                            <Input v-model="info.cusMobile" readonly></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="身份证号" prop="idCard">
                            <Input
                                v-model="info.idCard"
                                :rule-debounce="400"
                                :readonly="idCardReadonly"
                            ></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="客户来源" prop="cusSource">
                            <Select
                                v-model="info.cusSource"
                                :disabled="
                                    !isView &&
                                    (cusStatus == 3 || cusStatus == 4)
                                "
                            >
                                <Option
                                    v-for="item in cusSourceList"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.text }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="单位名称" prop="comName">
                            <Input
                                v-model="info.comName"
                                :maxlength="100"
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
                <template
                    v-if="cusStatus == 3 || cusStatus == 4 || cusStatus == 5"
                >
                    <Row :gutter="20">
                        <Col span="12">
                            <FormItem label="客户状态" prop="cusStatus">
                                <Input
                                    v-model="dict.cusStatus.val(cusStatus)"
                                    :maxlength="100"
                                    :disabled="!isView"
                                />
                            </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="20">
                        <Col span="24">
                            <FormItem label="房源名称" prop="houseName">
                                <Input
                                    v-model="info.houseName"
                                    type="textarea"
                                    :rows="3"
                                    disabled
                                ></Input>
                            </FormItem>
                        </Col>
                    </Row>
                </template>
                <Row :gutter="20">
                    <Col span="24">
                        <FormItem label="备注" prop="remark">
                            <Input
                                v-model="info.remark"
                                :maxlength="1000"
                                type="textarea"
                                placeholder="0/1000"
                                :rows="4"
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
            </template>
        </Form>
    </div>
</template>
<script>
import { cInfoView, cInfoAdd, cInfoUpdate, cusByIdentity } from '@/api/customer'
import { idCardCheck } from '@/api/sys-user'
import Dict from '_u/dict'
import { tel, idCard } from '_u/validate'
import mForm from '_v/common/m-form'

export default {
    name: 'c-info-yxkh-form',
    mixins: [mForm],
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
        cusStatus: {
            type: [String, Number],
        },
    },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            info: {
                id: this.id,
                cusBaseId: '', // 主库id
                cusName: '', //客户名称
                cusMobile: '', // 客户手机号码
                idCard: '', // 身份证号
                remark: '', // 备注
                cusSource: '', //客户来源
                houseName: '', //房源名称
                comName: '', // 单位名称
                ver: '', // 版本号
            },
            dict: {
                trackStatus: Dict.NULL,
                cusSource: Dict.NULL,
                cusStatus: Dict.NULL,
            },
            // state
            mobileError: '',
            innerMode: this.formMode,
            cusNameReadonly: false,
            idCardReadonly: false,
        }
    },
    computed: {
        ruleValidate() {
            return this.isView
                ? {}
                : {
                      cusName: [{ required: true, message: '客户名称必填' }],
                      cusMobile: [
                          { required: true, message: '客户手机号必填' },
                          { validator: tel, message: '客户手机号格式不正确' },
                      ],
                      idCard: [
                          { required: true, message: '身份证号必填' },
                          {
                              validator: idCard,
                              message: '身份证号格式不正确',
                              trigger: 'blur',
                          },
                      ],
                  }
        },
        trackStatusList() {
            return this.dict.trackStatus.toList()
        },
        cusSourceList() {
            return this.dict.cusSource.toList()
        },
    },
    watch: {
        innerMode: {
            handler(val) {
                var btns = []

                // 按钮配置
                if (val == this.FORM_MODE.add) {
                    btns = [
                        { type: 'primary', name: 'continue', text: '下一步' },
                        { type: 'default', name: 'cancel', text: '取消' },
                    ]
                } else if (val == this.FORM_MODE.update) {
                    btns = [
                        { type: 'primary', name: 'confirm', text: '确定' },
                        { type: 'default', name: 'cancel', text: '取消' },
                    ]
                } else {
                    btns = [{ type: 'default', name: 'cancel', text: '关闭' }]
                }
                this.$modal.updateBtns(btns)
            },
            immediate: true,
        },
    },
    methods: {
        fetch() {
            if (this.id) {
                return cInfoView(this.id)
            } else {
                return Promise.resolve()
            }
        },
        // 锁定敏感信息
        lockSensitiveInfo() {
            return Promise.resolve()
                .then(() => {
                    // 租客姓名不允许修改
                    this.cusNameReadonly = !!this.info.cusName
                })
                .then(() => {
                    if (this.info.idCard) {
                        return idCardCheck(this.info.idCard)
                    } else {
                        return Promise.reject()
                    }
                })
                .then(() => {
                    // 合法身份证，不允许修改
                    this.idCardReadonly = true
                })
                .catch((err) => {
                    this.idCardReadonly = false
                })
        },
    },
    mounted() {
        var $info = this.$refs.info

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([
                Dict.get(['track_status', 'cus_source', 'cus_status']),
                this.fetch(),
            ])
                .then((args) => {
                    var [dictGroup, view] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    if (view) {
                        var viewData = view.data
                        // 实体数据
                        if (viewData.entity) viewData = viewData.entity

                        Object.keys(this.info).forEach(
                            (name) => (this.info[name] = viewData[name])
                        )
                        if (!this.info.comName) {
                            this.info.comName = ''
                        }
                    }
                })
                .then(() => {
                    if (this.info.id) {
                        return this.lockSensitiveInfo()
                    }
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            var formData = {}

            $info
                .validate()
                .then(() => {
                    Object.assign(formData, this.info)

                    if (this.info.id) {
                        return cInfoUpdate(formData)
                    } else {
                        return cInfoAdd(formData)
                    }
                })
                .then((res) => {
                    var info = Object.assign({}, formData)

                    if (this.info.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        info.id = res.data?.cusId
                        info.cusBaseId = res.data?.cusBaseId
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                    this.$emit('save', info)
                })
                .catch(() => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })

        // 下一步
        this.$modal.onBtnClick('continue', (next, options) => {
            // 不关闭modal
            options.closeModal = false

            $info
                .validate()
                .then(() => cusByIdentity({ phone: this.info.cusMobile }))
                .then((res) => {
                    var internal = res.data?.internal,
                        datacenter = res.data?.datacenter

                    // 内部存在
                    if (internal) {
                        this.mobileError = '已有该客户，请核实'
                        return
                    }

                    // 主库存在
                    if (datacenter) {
                        Object.keys(this.info).forEach(
                            (name) => (this.info[name] = datacenter[name])
                        )
                        this.info.id = ''
                    }

                    // 编辑客户
                    this.innerMode = this.FORM_MODE.update

                    if (datacenter) {
                        return this.lockSensitiveInfo()
                    }
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>
<style lang="less" scoped></style>
